import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function NormalInput({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = "text",
  ...props
}) {
  // console.log(field, customFeedbackLabel, label, errors, props)
  return (
    <>
      {label && <label className={props.isRequired ? 'required' : '' }>{label}</label>}
      <input
        type={type}
        // className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        className="form-control"
        {...field}
        {...props}
      />
    </>
  );
}
